import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { CiCirclePlus, CiCircleRemove } from 'react-icons/ci';
import { FaTimes } from 'react-icons/fa';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import { TagModel } from '../../pages/tags/TagsIndex';
import CustomButton from '../CustomButton/CustomButton';
import { EstimateTag } from '../../models/estimate/EstimateViewModel';
import EstimateTagBadge from './EstimateTagBadge';

interface EstimateTagsProps {
  estimateId: number;
  refreshTags: () => void;
  items: EstimateTag[];
}

export default function EstimateTags({
  estimateId,
  items,
  refreshTags,
}: EstimateTagsProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [showTags, setShowTags] = useState(false);
  const [tags, setTags] = useState<TagModel[]>([]);

  const {
    user: { organization },
  } = useAuth();

  const getTags = async () => {
    try {
      setIsLoading(true);
      setShowTags(true);
      const { data } = await api.get(
        `organizations/${organization.id}/estimates/${estimateId}/tags/available`
      );
      setTags(data.data);
      setIsLoading(false);
    } catch (e: any) {
      console.log(e);
    }
  };

  async function addTag(tagId: string) {
    try {
      await api.post(
        `organizations/${organization.id}/estimates/${estimateId}/tags/${tagId}`
      );
      setShowTags(false);
      refreshTags();
      setTags([]);
      toast.success('A etiqueta foi adicionada com sucesso');
    } catch (e: any) {
      console.log(e);
    }
  }

  const removeTag = useCallback(
    async (estimateTag: EstimateTag) => {
      try {
        if (
          // eslint-disable-next-line no-restricted-globals
          confirm(
            `Você tem certeza que deseja remover a etiqueta"? Essa ação não poderá ser desfeita.`
          )
        ) {
          await api.delete(
            `organizations/${organization.id}/estimates/${estimateId}/tags/${estimateTag.tagId}`
          );
          refreshTags();
          toast.success(`A etiqueta foi removida do Orçamento`);
        }
      } catch (e) {
        toast.error(
          `Houve um problema ao tentar remover a etiqueta da Orçamento. Tente novamente.`
        );
      }
    },
    [organization.id, estimateId, refreshTags, toast]
  );

  return (
    <>
      <span className='h4'>Etiquetas</span>
      <div className='mt-1 d-flex gap-1 flex-wrap'>
        {items.map((t) => {
          return (
            <EstimateTagBadge
              key={t.tagId}
              tag={t}
              isCollapsable={false}
              removeTag={removeTag}
            />
          );
        })}
      </div>
      <div className='row mt-2'>
        {showTags && (
          <div className='mb-3 col-6'>
            <select
              required
              className='form-select'
              aria-label='Selecione a Etiqueta'
              onChange={(e) => addTag(e.target.value)}
            >
              <option value=''>Selecione a Etiqueta</option>
              {tags.map((t: any) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className='col-1'>
          {!showTags && (
            <CustomButton
              className='btn p-0 rounded-pill'
              type='button'
              style={{
                color: '#0d6efd',
                borderColor: '#0d6efd',
                border: 'none',
              }}
              handleClick={getTags}
            >
              <CiCirclePlus size={40} />
            </CustomButton>
          )}
          {showTags && (
            <button
              className='btn p-0 rounded-pill'
              type='button'
              style={{
                color: '#dc3545',
                borderColor: '#dc3545',
                border: 'none',
              }}
              onClick={() => setShowTags(false)}
            >
              <CiCircleRemove size={40} />
            </button>
          )}
        </div>
      </div>
    </>
  );
}
